import React from "react";
import OPOfflineIframe from "../../../iframe-component/operation-offline/OPOffIframe";

const OfflineEmailTemplate = () => {
  return <OPOfflineIframe path="/operation/email_template" />;
};

export default React.memo(OfflineEmailTemplate);
